import { create } from "zustand";
import { persist } from "zustand/middleware";
import { syncPersistedPreferences } from "./sync-persisted-preferences";
import type { VoiceWakePhase } from "./voice-wake-coordinator";

export const useVoiceWakePreference = create<{
  enabled: boolean;
  setEnabled: (enabled: boolean) => void;
}>()(
  persist(
    (set) => ({ enabled: false, setEnabled: (enabled) => set({ enabled }) }),
    {
      name: "denker-voice-wake",
      partialize: ({ enabled }) => ({ enabled }),
      merge: (saved, current) => ({
        ...current,
        enabled: (saved as { enabled?: unknown } | null)?.enabled === true,
      }),
    },
  ),
);
export const useVoiceWakeStatus = create<{
  phase: VoiceWakePhase;
  error?: string;
}>(() => ({ phase: "off" }));
const stopSync = syncPersistedPreferences({
  name: "voice-wake",
  read: () => ({ enabled: useVoiceWakePreference.getState().enabled }),
  subscribe: useVoiceWakePreference.subscribe,
  apply: (value) => {
    if (
      value &&
      typeof value === "object" &&
      typeof (value as { enabled?: unknown }).enabled === "boolean"
    )
      useVoiceWakePreference.setState({
        enabled: (value as { enabled: boolean }).enabled,
      });
  },
});
if (import.meta.hot) import.meta.hot.dispose(stopSync);
